import React from 'react';

import { useAppContext } from '@prisjakt/ui-app-context';

import {
  TonalButton,
  ButtonSize,
  ButtonText,
  ButtonIcon,
} from '@prisjakt/ui/button/variants';
import Clickable from '@prisjakt/ui-clickable';
import { IconMagnifier } from '@prisjakt/ui/icon';
import { Behavior } from '@prisjakt/ui/text';

import { addRecentSearch } from 'src/areas/search-suggestions/history-storage';

import * as S from './styles';

import {
  trackPopularSearchClicked,
  trackPopularSearchesListed,
} from './tracking';

import { PopularSearch } from 'src/types';
import { useEffectOnMount } from 'src/hooks/useEffectOnMount';

type Props = {
  popularSearches: Array<PopularSearch | null>;
  onClick?: (query: string) => void;
};

export const PopularSearches = (props: Props) => {
  const { popularSearches, onClick } = props;
  const { linkTo } = useAppContext();

  useEffectOnMount(() => {
    if (popularSearches?.length) {
      trackPopularSearchesListed();
    }
  });

  if (!popularSearches?.length) {
    return null;
  }

  const handleClick = (query: string) => {
    trackPopularSearchClicked(query);
    addRecentSearch(query);
    if (onClick) {
      onClick(query);
    }
  };

  return (
    <S.PopularSearches data-test="PopularSearchesWrapper">
      {popularSearches.map(
        search =>
          search?.query && (
            <TonalButton
              key={search.query}
              container={Clickable}
              containerProps={{
                to: linkTo('search', { query: search.query }),
                'data-test': 'PopularSearchQuery',
              }}
              onClick={() => handleClick(search.query)}
              size={ButtonSize.SMALL}
            >
              <ButtonIcon>
                <IconMagnifier />
              </ButtonIcon>
              <ButtonText behavior={Behavior.OnelineEllipsis}>
                {search.query}
              </ButtonText>
            </TonalButton>
          )
      )}
    </S.PopularSearches>
  );
};
